export function calculate(options) {

    if (getPeriodRank(options.regularDepositInterval) < 3 && options.compoundingInterval === 12) {
        return annualizeInvestment(options);
      }

    if (
        getPeriodRank(options.regularDepositInterval) >
        getPeriodRank(options.compoundingInterval)
      ) {
        //   console.log("In if===");
        return calculateCompoundingData(options);
      }


// Basic conditions are met, go forward
let points = [];

let perYear =
  getTotalDataPoints(options.regularDepositInterval, options.period) /
  options.period;

// Period-based totals
let depositsPerPeriod = getAdditionsPercompoundInterval(
//   options.regularDepositInterval,
  options.compoundingInterval
);

// console.log("CI=", options.compoundingInterval, "DPP=", depositsPerPeriod);
let depositsThisPeriod = 0;
let periodDeposit = 0;
let periodInterest = 0;
let currentPeriod = 1;

// Totals
options.initialInvestment = parseFloat(options.initialInvestment);
let currentValue = options.initialInvestment;
let totalInvested = options.initialInvestment;
let totalInterest = 0;

for (
  let i = 1;
  i <= getTotalDataPoints(options.regularDepositInterval, options.period);
  i++
) {
  // Construct a default point
  let point = {
    depositNum: i,
    deposit: options.amount,
    periodNum: currentPeriod,
    periodDeposit: 0,
    periodInterest: 0,
    totalInterest: 0,
    // totalInvested: options.amount ? i * options.amount : totalInvested,
    totalInvested: options.amount ? i * options.amount : totalInvested,
    currentValue: 0,
  };

  // Defaults for depositing
  options.amount = parseFloat(options.amount);
  periodDeposit += options.amount;
//   periodDeposit = parseInt(periodDeposit, 10);

  // Update deposits for this period
  depositsThisPeriod += 1;

  // If this is a compounding period, compound away
  if (depositsThisPeriod === depositsPerPeriod) {
    // Calculate interest based on last amount
    periodInterest +=
      (currentValue - periodDeposit + options.amount) *
      getInterestPerPeriod(options);
    totalInterest += periodInterest;
    if(i===1) {
        // console.log("Pi-=", periodInterest, typeof periodInterest,"CV=", currentValue, typeof currentValue, 
        // "PD=", periodDeposit, typeof periodDeposit, "Amt=",options.amount, typeof options.amount, "IP=",getInterestPerPeriod(options));
    }

    // Set the data values accordingly
    point.periodDeposit = periodDeposit;
    point.periodInterest = periodInterest;
    point.totalInterest = totalInterest;

    // Update current value
    currentValue += options.amount + periodInterest;
    // if(i===1) {
    //     currentValue += periodInterest
    // }
    // else {
    //     currentValue += options.amount + periodInterest;
    // }

    // Reset values
    periodDeposit = 0;
    periodInterest = 0;
    depositsThisPeriod = 0;

    // Update current period
    currentPeriod += 1;
  } else {
    // Hide the period number
    point.periodNum = -1;
    point.periodInterest = -1;
    point.periodDeposit = -1;

    // If it's not a compound period, we have partial interest to calculate
    // if(i===1) {
    //     periodInterest +=
    //   options.amount *
    //   (getInterestPerPeriod(options) *
    //     (depositsThisPeriod / depositsPerPeriod));
        
    // // Add the current value
    // currentValue += 0;
    // console.log("In i 1 for quarter", currentValue)
    // }
    // else {
    //     periodInterest +=
    //   options.amount *
    //   (getInterestPerPeriod(options) *
    //     (depositsThisPeriod / depositsPerPeriod));

    // // Add the current value
    // currentValue += options.amount;
    // }
    periodInterest +=
      options.amount *
      (getInterestPerPeriod(options) *
        (depositsThisPeriod / depositsPerPeriod));

    // Add the current value
    currentValue += options.amount;
    
  }

  // Update year end
  if (i % perYear === 0) {
    point.isYearEnd = true;
  }

  point.currentValue = currentValue;

  points.push(point);
}

return points;
}


function calculateCompoundingData(options) {
    let points = [];
  
    // console.log("CI=", options.compoundingInterval, "Period=", options.period);
    let perYear =
      getTotalDataPoints(options.compoundingInterval, options.period) /
      options.period;
  
    // Period-based totals
    let compoundsPerDeposit = getAdditionsPercompoundInterval(
      options.compoundingInterval
    );

    // console.log(`PYear=  ${perYear}, compoundsPerDeposit ${compoundsPerDeposit}`);
    let compoundsSinceLastDeposit = 0;
    let currentDeposit = 1;
  
    // Totals
    let currentValue = options.initialInvestment;
    let totalInvested = options.initialInvestment;
    let totalInterest = 0;
  
    for (
      let i = 1;
      i <= getTotalDataPoints(options.compoundingInterval, options.period);
      i++
    ) {
      // Construct a default point
      let point = {
        depositNum: -1,
        deposit: -1,
        periodNum: i,
        periodDeposit: -1,
        periodInterest: 0,
        totalInterest: 0,
        totalInvested: totalInvested,
        currentValue: 0,
        isYearEnd: false,
      };
  
      // Complete a compound based on the current value
      point.periodInterest = currentValue * getInterestPerPeriod(options);
      totalInterest += point.periodInterest;
      point.totalInterest = totalInterest;
  
      // Update the compounds
      compoundsSinceLastDeposit += 1;
  
      // Update the current value
      currentValue += point.periodInterest;
  
      // Do an addition if called for
      if (compoundsSinceLastDeposit === compoundsPerDeposit) {
        point.depositNum = currentDeposit;
  
        // Add the deposit
        totalInvested += options.amount;
  
        options.amount = parseFloat(options.amount);
        point.deposit = options.amount;
        point.periodDeposit = options.amount;
        point.totalInvested = totalInvested;
  
        currentValue += options.amount;
  
        // Reset the trackers
        compoundsSinceLastDeposit = 0;
        currentDeposit += 1;
      }
  
      // Update the current value
      point.currentValue = currentValue;
  
      // Update year end
      if (i % perYear === 0) {
        point.isYearEnd = true;
      }
  
      points.push(point);
    }
  
    return points;
  }


  /**
 * 
 */
function annualizeInvestment(options) {
    let points = [];
  
    let months = 13;
  
    let depositsPerPeriod = 0;
  
    if (options.regularDepositInterval === "daily") {
      depositsPerPeriod = 28;
    } else if (options.regularDepositInterval === "weekly") {
      depositsPerPeriod = 4;
    } else depositsPerPeriod = 2;
  
    let perYear = months * depositsPerPeriod;
    let annualizedPeriodInterest = options.rate / 13 / 100.0;
  
    // Period-based totals
    let depositsThisPeriod = 0;
    let periodDeposit = 0;
    let periodInterest = 0;
    let currentPeriod = 1;
  
    // Totals
    let currentValue = options.initialInvestment;
    let totalInterest = 0;
  
    for (let i = 1; i <= options.timeframe * perYear; i++) {
      // Construct a default point
      let point = {
        depositNum: i,
        deposit: options.regularDepositAmount,
        periodNum: currentPeriod,
        periodDeposit: 0,
        periodInterest: 0,
        totalInterest: 0,
        totalInvested: i * options.regularDepositAmount,
        currentValue: 0,
      };
  
      // Defaults for depositing
      options.regularDepositAmount = parseFloat(options.regularDepositAmount);
      periodDeposit += options.regularDepositAmount;
  
      // Update deposits for this period
      depositsThisPeriod += 1;
  
      // If this is a compounding period, compound away
      if (depositsThisPeriod === depositsPerPeriod) {
        // Calculate interest based on last amount
        periodInterest += (currentValue - periodDeposit + options.regularDepositAmount) * annualizedPeriodInterest;
        totalInterest += periodInterest;
  
        // Set the data values accordingly
        point.periodDeposit = periodDeposit;
        point.periodInterest = periodInterest;
        point.totalInterest = totalInterest;
  
        // Update current value
        currentValue += options.regularDepositAmount + periodInterest;
  
        // Reset values
        periodDeposit = 0;
        periodInterest = 0;
        depositsThisPeriod = 0;
  
        // Update current period
        currentPeriod += 1;
      } else {
        // Hide the period number
        point.periodNum = -1;
        point.periodInterest = -1;
        point.periodDeposit = -1;
  
        // If it's not a compound period, we have partial interest to calculate
        periodInterest +=
          options.regularDepositAmount *
          (getInterestPerPeriod(options) *
            (depositsThisPeriod / depositsPerPeriod));
  
        // Add the current value
        currentValue += options.regularDepositAmount;
      }
  
      // Update year end
      if (i % perYear === 0) {
        point.isYearEnd = true;
      }
  
      point.currentValue = currentValue;
  
      points.push(point);
    }
  
    return points;
  }

  function getTotalDataPoints(additionPeriod, timeline) {
    switch (additionPeriod.toString()) {
    //   case "daily":
    //     return 365 * timeline;
    //   case "weekly":
    //     return 52 * timeline;
    //   case "bi-weekly":
    //     return 26 * timeline;
      case "12":
        return 12 * timeline;
      case "4":
        return 4 * timeline;
      case "2":
        return 2 * timeline;
      case "1":
        return timeline;
      default: return -1;
    }
  }


  function getAdditionsPercompoundInterval(compoundInterval) {
    // console.log("Case in switch=", compoundInterval)
    switch (true) {
        default: {
            switch (compoundInterval.toString()) {
            case "12":
              return 1;
            case "4":
              return 3;
            case "2":
              return 6;
            case "1":
              return 12;
            default: return -1;
          }
        }   
    }
  }

  
  function getInterestPerPeriod(options) {
    switch (options.compoundingInterval.toString()) {
    //   case "daily":
    //     return options.interestRate / 365 / 100.0;
    //   case "weekly":
    //     return options.interestRate / 52 / 100.0;
    //   case "bi-weekly":
    //     return options.interestRate / 26 / 100.0;
      case "12":
        return options.rate / 12 / 100.0;
      case "4":
        return options.rate / 4 / 100.0;
      case "2":
        return options.rate / 2 / 100.0;
      case "1":
        return options.rate / 100;
      default: return -1;
    }
  }

  function getPeriodRank(period) {
    switch (period.toString()) {
    //   case "daily":
    //     return 0;
    //   case "weekly":
    //     return 1;
    //   case "bi-weekly":
    //     return 2;
      case "12":
        return 3;
      case "4":
        return 4;
      case "2":
        return 5;
      case "1":
        return 6;
      default: return -1;
    }
  }